var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 8,
    viewBox: "0 0 110 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.354 4.26127C109.549 4.06601 109.549 3.74942 109.354 3.55416L106.172 0.372181C105.976 0.176919 105.66 0.176919 105.464 0.372181C105.269 0.567443 105.269 0.884026 105.464 1.07929L108.293 3.90771L105.464 6.73614C105.269 6.9314 105.269 7.24799 105.464 7.44325C105.66 7.63851 105.976 7.63851 106.172 7.44325L109.354 4.26127ZM0 4.40771L109 4.40771V3.40771L0 3.40771L0 4.40771Z",
    fill: "#C0162E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessArrow);
export default __webpack_public_path__ + "static/media/process--arrow.a08d684508946b5f6144c701579bb4ab.svg";
export { ForwardRef as ReactComponent };